import './react-polyfills';
// it will be replaced by babel-preset-env to more specific polyfills
// https://babeljs.io/docs/plugins/preset-env/#optionsuse-built-ins
import 'babel-polyfill';
import React from 'react';
import i18n from 'i18next';

import { runApplication, ApplicationRenderer } from '@unitedtraders/application-bootstrapper';
import { createAuthorization } from './services/keycloak';
import defaultSettings from './defaultSettings';
import { Routes } from './routes';
import qs from 'querystring';
import ReduxApp from './components/ReduxApp';
import PageLoading from './blocks/pageLoading/PageLoading';
import './styles/index.scss';
import './static/icon.font.js';

import { createDomain as createStatementsDomain } from '@unitedtraders/statements-domain';
import { Modals } from './components/Modals';
export { Document, SiteHead } from './document';
export { getGitSettings } from './defaultSettings';

export function initApplicationRoot({ history, language, overrideSettings }) {
  if (language) {
    options.defaultSettings.i18n.lng = language;
  }

  const tokens = ejectTokensFromUrl(history);

  const application = runApplication(
    Object.assign({}, options, {
      history,
      authorizationFactory: (...args) => createAuthorization(tokens, ...args),
      overrideSettings
    })
  );

  const rootElem = <ApplicationRoot application={application} />;
  return { application, rootElem };
}

const options = {
  appName: 'utcom-web-ui',
  defaultSettings,
  beforeInitialRender
};

function beforeInitialRender(app) {
  const commonConfig = {
    contentLanguages: {
      list: Object.keys(app.settings.get('i18n').resources)
    }
  };

  const statementsHateoasModule = createStatementsDomain(
    app.settings.get('statementsHateoas').hostUrl,
    app.superAgent,
    commonConfig
  );

  app.registerDomain('statements', statementsHateoasModule);

  i18n.on('languageChanged', () => deleteLanguageParam(app.history));
}

function ApplicationRoot({ application }) {
  return (
    <ApplicationRenderer application={application} LoaderView={PageLoading}>
      <ReduxApp>
        <Routes history={application.history} />
        <Modals />
      </ReduxApp>
    </ApplicationRenderer>
  );
}

function deleteLanguageParam(history) {
  const { pathname, search, hash } = history.location;
  if (!search) {
    return;
  }

  const query = qs.decode(search.substring(1)); // cut leading "?"
  if (!query.lng) {
    return;
  }
  delete query.lng;
  let newSearch = qs.encode(query);
  if (newSearch) {
    newSearch = `?${newSearch}`;
  }
  history.replace(`${pathname}${newSearch}${hash}`);
}

function ejectTokensFromUrl(history) {
  const { pathname, search, hash } = history.location;
  if (!hash) {
    return null;
  }
  const { access_token, refresh_token, ...rest } = qs.decode(hash.substring(1)); // cut leading "#"

  if (!access_token) {
    return null;
  }

  const tokens = {
    access_token,
    refresh_token
  };

  const newHash = Object.keys(rest).length ? `#${qs.encode(rest)}` : '';

  history.replace(`${pathname}${search}${newHash}`);
  return tokens;
}



// WEBPACK FOOTER //
// ./src/index.js